(function () {
  const SHORTCODE_REGEX = /\[product_card\s+handle=["']([^"']+)["']\s*\]/gi;

  // --- Inisialisasi satu kartu produk ---
  function initInlineProductCard(root) {
    if (!root || root.dataset.ipcBound === "true") return;
    root.dataset.ipcBound = "true";

    const dataEl = root.querySelector(".ipc-data");
    if (!dataEl) return;

    let data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error("IPC: gagal parse data JSON", e);
      return;
    }

    const variants = data.variants || [];
    const currency = data.currency;

    const selects = root.querySelectorAll(".ipc-select");
    const chips = root.querySelectorAll(".ipc-chip");
    const qtyInput = root.querySelector("[data-qty]");
    const decBtn = root.querySelector("[data-qty-dec]");
    const incBtn = root.querySelector("[data-qty-inc]");
    const priceEl = root.querySelector("[data-price]");
    const compareEl = root.querySelector("[data-compare]");
    const statusEl = root.querySelector("[data-status]");
    const addBtn = root.querySelector("[data-add-to-cart]");
    const buyBtn = root.querySelector("[data-buy-now]");

    const money = function (cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || "id", {
          style: "currency",
          currency: currency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(cents / 100);
      } catch (e) {
        // fallback kalau Intl gagal: bulatkan & pakai pemisah ribuan lokal
        const unit = Math.round(cents / 100);
        return unit.toLocaleString("id-ID") + " " + currency;
      }
    };

    function getSelectedValues() {
      const selected = [];

      // Prioritas dari chip
      if (chips.length) {
        chips.forEach(function (ch) {
          if (ch.getAttribute("aria-pressed") === "true") {
            const idx = Number(ch.getAttribute("data-option-index") || "0");
            selected[idx] = ch.getAttribute("data-value");
          }
        });
      }

      // Fallback / lengkapkan dari select (hidden)
      if (selects.length) {
        selects.forEach(function (sel, i) {
          if (!selected[i]) selected[i] = sel.value;
        });
      }

      return selected;
    }

    function findVariant() {
      if (!variants.length) return null;

      const selected = getSelectedValues();
      if (!selected.length) {
        return (
          variants.find(function (v) {
            return v.available;
          }) ||
          variants[0] ||
          null
        );
      }

      return (
        variants.find(function (v) {
          return v.options.every(function (opt, i) {
            return !selected[i] || selected[i] === opt;
          });
        }) || null
      );
    }

    function updateUI() {
      const v = findVariant();

      // qty selalu minimal 1
      const qty = qtyInput
        ? Math.max(1, parseInt(qtyInput.value || "1", 10) || 1)
        : 1;

      if (!v) {
        if (addBtn) addBtn.disabled = true;
        if (buyBtn) buyBtn.disabled = true;
        if (priceEl) priceEl.textContent = "";
        if (compareEl) compareEl.hidden = true;
        if (statusEl)
          statusEl.textContent = "Pilih kombinasi opsi yang tersedia";
        return;
      }

      const available = !!v.available;

      // HARGA TOTAL = harga varian × qty
      if (priceEl) priceEl.textContent = money(v.price * qty);

      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price * qty);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.dataset.variantId = v.id;
      }
      if (buyBtn) {
        buyBtn.disabled = !available;
        buyBtn.dataset.variantId = v.id;
      }

      if (statusEl) {
        statusEl.textContent = available ? "" : "Stok habis";
      }
    }

    // Sinkronisasi select <-> chip
    selects.forEach(function (sel) {
      sel.addEventListener("change", function () {
        const idx = Number(sel.getAttribute("data-option-index") || "0");
        const val = sel.value;
        root
          .querySelectorAll('.ipc-chip[data-option-index="' + idx + '"]')
          .forEach(function (ch) {
            ch.setAttribute(
              "aria-pressed",
              ch.getAttribute("data-value") === val ? "true" : "false"
            );
          });
        updateUI();
      });
    });

    chips.forEach(function (ch) {
      ch.addEventListener("click", function () {
        if (ch.disabled) return;
        const idx = Number(ch.getAttribute("data-option-index") || "0");
        const val = ch.getAttribute("data-value");

        // toggle dalam grup
        root
          .querySelectorAll('.ipc-chip[data-option-index="' + idx + '"]')
          .forEach(function (btn) {
            btn.setAttribute("aria-pressed", btn === ch ? "true" : "false");
          });

        // update hidden select (kalau ada)
        selects.forEach(function (sel) {
          const sIdx = Number(sel.getAttribute("data-option-index") || "0");
          if (sIdx === idx) {
            sel.value = val;
          }
        });

        updateUI();
      });
    });

    // Qty
    if (decBtn && qtyInput) {
      decBtn.addEventListener("click", function () {
        var n = Math.max(1, parseInt(qtyInput.value || "1", 10) - 1);
        qtyInput.value = n;
        updateUI(); // <- refresh harga
      });
    }

    if (incBtn && qtyInput) {
      incBtn.addEventListener("click", function () {
        var n = Math.max(1, parseInt(qtyInput.value || "1", 10) + 1);
        qtyInput.value = n;
        updateUI(); // <- refresh harga
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener("input", function () {
        var n = Math.max(1, parseInt(qtyInput.value || "1", 10) || 1);
        qtyInput.value = n;
        updateUI(); // <- refresh harga
      });
    }

    // ADD TO CART
    if (addBtn && qtyInput) {
      addBtn.addEventListener("click", function () {
        const id = addBtn.dataset.variantId;
        const quantity = Math.max(1, parseInt(qtyInput.value || "1", 10));
        if (!id) return;

        const original = addBtn.innerHTML;
        addBtn.disabled = true;
        addBtn.innerHTML = "...";

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ id: id, quantity: quantity }),
        })
          .then(function (res) {
            if (!res.ok) throw new Error("Add failed");
            if (statusEl) statusEl.textContent = "Ditambahkan ke keranjang";
          })
          .catch(function (e) {
            console.error(e);
            if (statusEl) statusEl.textContent = "Gagal menambah ke keranjang";
          })
          .finally(function () {
            addBtn.innerHTML = original;
            addBtn.disabled = false;
          });
      });
    }

    // BUY NOW → checkout
    if (buyBtn && qtyInput) {
      buyBtn.addEventListener("click", function () {
        const id = buyBtn.dataset.variantId;
        const quantity = Math.max(1, parseInt(qtyInput.value || "1", 10));
        if (!id) return;

        const original = buyBtn.textContent;
        buyBtn.disabled = true;
        buyBtn.textContent = "Memproses…";

        // optional: clear cart dulu
        fetch("/cart/clear.js", { method: "POST" })
          .catch(function (e) {
            console.warn("Gagal clear cart", e);
          })
          .finally(function () {
            fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify({ id: id, quantity: quantity }),
            })
              .then(function (res) {
                if (!res.ok) throw new Error("Add failed");
                window.location.href = "/checkout";
              })
              .catch(function (e) {
                console.error(e);
                buyBtn.disabled = false;
                buyBtn.textContent = "Coba lagi";
                if (statusEl)
                  statusEl.textContent = "Tidak bisa lanjut ke checkout";
                setTimeout(function () {
                  buyBtn.textContent = original;
                }, 1500);
              });
          });
      });
    }

    // initial state
    updateUI();
  }

  // --- Proses shortcode di konten ---
  function processShortcodes(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const replacements = [];

    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (!node.nodeValue) continue;

      SHORTCODE_REGEX.lastIndex = 0;
      if (!SHORTCODE_REGEX.test(node.nodeValue)) continue;
      SHORTCODE_REGEX.lastIndex = 0;

      const wrapper = document.createElement("span");
      wrapper.innerHTML = node.nodeValue.replace(
        SHORTCODE_REGEX,
        function (_, handle) {
          return (
            '<span class="ipc-placeholder" data-handle="' + handle + '"></span>'
          );
        }
      );
      replacements.push([node, wrapper]);
    }

    replacements.forEach(function (pair) {
      const textNode = pair[0];
      const el = pair[1];
      if (textNode.parentNode) {
        textNode.parentNode.replaceChild(el, textNode);
      }
    });

    document
      .querySelectorAll(".ipc-placeholder[data-handle]")
      .forEach(function (ph) {
        const handle = ph.getAttribute("data-handle");
        fetch("/products/" + encodeURIComponent(handle) + "?view=inline-card")
          .then(function (res) {
            return res.text();
          })
          .then(function (html) {
            const tmp = document.createElement("div");
            tmp.innerHTML = html;
            const card = tmp.firstElementChild;
            if (card) {
              ph.replaceWith(card);
              initInlineProductCard(card);
            } else {
              ph.textContent = "Produk tidak ditemukan: " + handle;
            }
          })
          .catch(function () {
            ph.textContent = "Gagal memuat produk: " + handle;
          });
      });
  }

  document.addEventListener("DOMContentLoaded", function () {
    processShortcodes(document.body);
  });
})();
